export default __webpack_public_path__ + "static/media/accounting.d33d16b6.png";